import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary/15 text-primary",
        secondary: "border-transparent bg-surface-muted text-foreground",
        outline: "border-border text-foreground",
        destructive: "border-transparent bg-destructive/15 text-destructive",
        category: "border-transparent text-white",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// Helper to colorize by forum activity category
export function CategoryBadge({ category }: { category: string }) {
  const cls: Record<string, string> = {
    hot: "bg-cat-hot",
    active: "bg-cat-active",
    quiet: "bg-cat-quiet",
    dormant: "bg-cat-dormant",
    dead: "bg-cat-dead",
    unknown: "bg-cat-unknown",
  };
  return (
    <Badge variant="category" className={cls[category] ?? "bg-cat-unknown"}>
      {category}
    </Badge>
  );
}
